
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import banner from "./images/perfect.svg";

const Perfect = ({heading, text}) => {
    return (
        <div styleName={"styles.perfectWrap"}>
            <img src={banner} alt="Perfect Parts" />
            <h2>{heading}</h2>
            <p>{text}</p>
        </div>
    );
};

Perfect.propTypes = {
    heading: PropTypes.string,
    text: PropTypes.string
};
export default Perfect;
